export default {
    name: "LayoutSouvenir"
};
